import { proceedErrorMessages } from 'data/constants';
import { ActiveTabType, ExistingSystemType } from 'data/types';
import {
  componentsHaveRequiredAttributes,
  getExistingEquipmentComponents
} from 'utils/existing-equipment';

export const REQUIRED_COMPONENT_ATTRIBUTES_MESSAGE =
  'Fill in every required attribute on each component before continuing.';

export const EXISTING_EQUIPMENT_PAGE_TITLE_KEY =
  'step_existing_equipment_title';

export const EXISTING_EQUIPMENT_PAGE_TITLE =
  'What type of equipment do you have?';

export const EXISTING_PTAC_PAGE_TITLE_KEY =
  'step_existing_equipment_title_ptac';

export const EXISTING_PTAC_PAGE_TITLE = 'Tell us about the existing PTAC units';

export const ADD_ANOTHER_SYSTEM_LABEL = 'Add another system';

export const EQUIPMENT_PREFERENCES_PAGE_TITLE_KEY =
  'step_existing_equipment_want_title';

export const EQUIPMENT_PREFERENCES_PAGE_TITLE =
  'What type of equipment do you want?';

export function existingEquipmentHasInventory(componentCount: number): boolean {
  return componentCount > 0;
}

export function equipmentStepProceedMessage(args: {
  tab: ActiveTabType;
  existingSystems: ExistingSystemType[];
}): string {
  const components = getExistingEquipmentComponents(args.existingSystems);
  if (
    (args.tab === 'existingEquipment' || args.tab === 'equipmentPreferences') &&
    existingEquipmentHasInventory(components.length) &&
    !componentsHaveRequiredAttributes(components)
  ) {
    return REQUIRED_COMPONENT_ATTRIBUTES_MESSAGE;
  }
  return proceedErrorMessages[args.tab];
}
